export default {
      id: "close-circle-usage",
      viewBox: "0 0 49 49",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#close-circle",
      toString: function () {
        return this.url;
      }
    }